import { theme } from 'theme'
import styled, { css } from 'particles/themes/styled'
import Loading from 'components/Loading'
import { SemanticColors } from 'particles/colors'

export type IndicatorColor = keyof SemanticColors['indicator']

export const CampaignListLayout = styled.div`
    max-width: 1850px;
    .campaigns-card-layout {
        display: grid;
        gap: ${theme.gutter.s};
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        @media screen and (min-width: 375px) {
            grid-template-columns: repeat(1, minmax(200px, 1fr));
        }
        @media screen and (min-width: 425px) {
            grid-template-columns: repeat(2, minmax(200px, 1fr));
        }
        @media screen and (min-width: 768px) {
            grid-template-columns: repeat(3, minmax(200px, 1fr));
        }
        @media screen and (min-width: 1024px) {
            grid-template-columns: repeat(4, minmax(200px, 1fr));
        }
        @media screen and (min-width: 1280px) {
            grid-template-columns: repeat(5, minmax(200px, 1fr));
        }
        @media screen and (min-width: 1500px) {
            grid-template-columns: repeat(6, minmax(200px, 1fr));
        }
    }
`

export const SecondHeader = styled.div`
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    box-sizing: border-box;
    align-items: center;
    @media screen and (max-width: 375px) {
        flex-direction: column;
        align-items: flex-start;
        padding: 0 1rem;
    }
`

interface CardProp {
    decBarColor: IndicatorColor
    withTeamTypeTag?: boolean
}

export const Card = styled.div<CardProp>`
    height: ${({ withTeamTypeTag }) => (withTeamTypeTag ? '372px' : '344px')};
    background-color: ${theme.newColors.neutral50};
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    position: relative;
    box-sizing: border-box;
    &:after {
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        border-radius: 8px 8px 0 0;
        width: 100%;
        height: 8px;
        ${props => ({
            backgroundColor: props?.theme?.colors?.indicator?.[props.decBarColor],
        })}
    }
    .campaign-status {
        display: block;
        box-sizing: border-box;
    }
    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 16px 16px 0px 16px;
    }
    .card-main-info {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 12px;
        box-sizing: border-box;
        padding: 0 16px 16px 16px;
    }
    .campaign-type {
        display: flex;
        gap: ${({ theme }) => theme.spacing[100]};
    }
    .Campaign-title,
    .brand-name {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .Campaign-title {
        height: 164px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 7;
        white-space: normal;
        word-break: break-word;
    }
    .card-footer {
        display: flex;
        gap: 8px;
        width: 100%;
        height: fit-content;
        padding: 6px 16px;
        box-sizing: border-box;
    }
    .campaign-country {
        padding-right: 6px;
        border-right: 1px solid gray;
    }
`
interface StyledLoadingProps {
    loadMore?: boolean
}

export const StyledLoading = styled(Loading)<StyledLoadingProps>`
    position: ${({ loadMore }) => (loadMore ? 'relative' : 'absolute')};
    ${({ loadMore }) =>
        !loadMore &&
        css`
            top: 50%;
            transform: translateY(-50%);
            left: 50%;
        `}
`
